import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "register-box" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "register-title" }, "Estamos quase lá...", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "register-subtitle" }, " Queremos saber mais sobre você. Por favor forneça as informações abaixo... ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "fullName" }, "Nome completo:", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "fullName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
              class: _normalizeClass({ 'invalid-input': _ctx.fullNameError }),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateFullName && _ctx.validateFullName(...args))),
              required: "",
              placeholder: "Seu nome completo"
            }, null, 34), [
              [_vModelText, _ctx.fullName]
            ]),
            (_ctx.fullNameError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.fullNameError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "lattesLink" }, "Currículo Lattes(opcional):", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "url",
              id: "lattesLink",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lattesLink) = $event)),
              class: _normalizeClass({ 'invalid-input': _ctx.lattesLinkError }),
              onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateLattesLink && _ctx.validateLattesLink(...args))),
              placeholder: "Link para o Currículo Lattes (opcional)"
            }, null, 34), [
              [_vModelText, _ctx.lattesLink]
            ]),
            (_ctx.lattesLinkError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.lattesLinkError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "educationLevel" }, "Escolaridade:", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "educationLevel",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.educationLevel) = $event)),
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationOptions, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.id,
                  value: option.name
                }, _toDisplayString(option.name), 9, _hoisted_8))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.educationLevel]
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            type: "submit",
            class: "register-button"
          }, "Continuar", -1))
        ], 32)
      ]),
      (_ctx.snackbar.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['snackbar', _ctx.snackbar.color])
          }, _toDisplayString(_ctx.snackbar.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}